const initialState = {
  loadingSalesStats: false,
  salesStatsSummaryLoaded: false,
  salesStatsError: null,
  // `data: []` en cada bucket porque la vista lo lee sin comprobarlo, y `tt`
  // porque el microservicio lo aporta (TikTok no existe en el monolito).
  messagesByPlatform: {
    ws: { total_inbound: 0, total_outbound: 0, total_messages: 0, data: [] },
    msn: { total_inbound: 0, total_outbound: 0, total_messages: 0, data: [] },
    ig: { total_inbound: 0, total_outbound: 0, total_messages: 0, data: [] },
    tt: { total_inbound: 0, total_outbound: 0, total_messages: 0, data: [] }
  },
  usageByPlatform: {
    percentage_total_ws_messages: 0,
    percentage_total_msn_messages: 0,
    percentage_total_ig_messages: 0,
    percentage_total_tt_messages: 0
  },
  salesByPlatform: [],
  salesByPaymentMethod: {
    cash: { count: 0, total: 0 },
    credit_card: { count: 0, total: 0 },
    wire_transfer: { count: 0, total: 0 },
    paypal: { count: 0, total: 0 }
  },
  measuredConversationsCount: 0,
  averageResponseTimes: [],
  responseTimesByHour: [],
  averageResponseTimesError: false,
  responseTimesByHourError: false,
  miaHandoffStats: null,
  miaHandoffAgentStats: [],
  mostUsedTags: [],
  newAndRecurringConversationsData: [],
  newAndRecurringClientsData: [],
  customersCreatedCount: 0,
  agentPerformance: [],
  agentChats: [],
  setMessagesBy: [],
  leadsByAgent: {
    total_leads: 0,
    unassigned_leads: 0,
    assigned_leads_total: 0,
    leads_by_agent: []
  },
  messagesByHour: [],
  newContactsByHour: [],
  responseTimesRule: false,
  ordersCount: {
    total: 0,
    success: 0,
    pending: 0,
    canceled: 0
  },
  salesStat: {
    total: 0,
    pending: 0
  },
  salesReconciliation: {
    totalSalesAllOrders: 0,
    totalSalesAttributedProducts: 0,
    totalSalesUnattributed: 0
  },
  dailySalesStat: { total: 0, pending: 0, success: 0 },
  transactionsCount: 0,
  salesByAgent: [],
  salesByCustomerStat: [],
  salesByProductStat: [],
  salesByCategoryStat: [],
  salesBySubcategoryStat: [],
  salesByCampaign: [],
  salesByBrandStat: [],
  totalTags: 0,
  tagStats: [],
  attributionChannelStats: null,
  attributionFunnelPipelineStats: null,
  attributionChannelStatsLoading: false,
  attributionChannelStatsError: null,
  attributionFunnelPipelineStatsLoading: false,
  attributionFunnelPipelineStatsError: null
};

const statsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MESSAGES_BY_PLATFORM_DATA': {
      // El thunk ya entrega el objeto completo, pero el nombre de la acción es
      // público: sin este default, un payload incompleto dejaría el slice en
      // `undefined` y la vista se cae al leer `mp.ws.total_messages`.
      return {
        ...state,
        messagesByPlatform:
          action.data?.messages_by_platform ?? initialState.messagesByPlatform
      }
    }
    case 'SET_USAGE_BY_PLATFORM_DATA': {
      return {
        ...state,
        usageByPlatform:
          action.data?.usage_by_platform ?? initialState.usageByPlatform
      }
    }
    case 'SET_MEASURED_CONVERSATIONS_COUNT': {
      return {
        ...state,
        measuredConversationsCount: action.data.measured_conversations_count ?? 0
      };
    }
    case 'LOAD_AVERAGE_RESPONSE_TIMES':
      return { ...state, averageResponseTimes: [], averageResponseTimesError: false };
    case 'AVERAGE_RESPONSE_TIMES_FAILURE':
      return { ...state, averageResponseTimes: [], averageResponseTimesError: true };
    case 'LOAD_RESPONSE_TIMES_BY_HOUR':
      return { ...state, responseTimesByHour: [], responseTimesByHourError: false };
    case 'RESPONSE_TIMES_BY_HOUR_FAILURE':
      return { ...state, responseTimesByHour: [], responseTimesByHourError: true };
    case 'SET_AVERAGE_RESPONSE_TIMES_DATA': {
      return {
        ...state,
        averageResponseTimes: action.data.average_response_times,
        averageResponseTimesError: false
      };
    }
    case 'SET_RESPONSE_TIMES_BY_HOUR_DATA': {
      const responseTimeRule = action.data.error !== 'inactive rule';
      return {
        ...state,
        responseTimesByHour: action.data.data,
        responseTimesRule: responseTimeRule,
        responseTimesByHourError: false
      };
    }
    case 'SET_MOST_USED_TAGS_DATA': {
      return {
        ...state,
        mostUsedTags: action.data.most_used_tags
      };
    }
    case 'SET_CUSTOMERS_CREATED_COUNT': {
      return {
        ...state,
        customersCreatedCount: Number(action.data?.customers_created_count) || 0
      };
    }
    case 'SET_NEW_AND_RECURRING_CLIENTS_DATA': {
      const customersData = action.data?.customers_data || {};
      return {
        ...state,
        newAndRecurringClientsData: {
          new_customers: Number(customersData.new_customers) || 0,
          new_customers_percentage: Number(customersData.new_customers_percentage) || 0,
          recurring_customers: Number(customersData.recurring_customers) || 0,
          recurring_customers_percentage: Number(customersData.recurring_customers_percentage) || 0,
          total_customers: Number(customersData.total_customers) || 0
        }
      };
    }
    case 'SET_AGENT_CHATS_DATA': {
      return {
        ...state,
        agentChats: action.data.agent_chats
      };
    }
    case 'SET_SENT_MESSAGES_DATA': {
      return {
        ...state,
        setMessagesBy: action.data.sent_messages
      };
    }
    case 'SET_LEADS_BY_AGENT_DATA': {
      const data = action.data || {};
      return {
        ...state,
        leadsByAgent: {
          total_leads: Number(data.total_leads) || 0,
          unassigned_leads: Number(data.unassigned_leads) || 0,
          assigned_leads_total: Number(data.assigned_leads_total) || 0,
          leads_by_agent: Array.isArray(data.leads_by_agent) ? data.leads_by_agent : []
        }
      };
    }
    case 'SET_MIA_HANDOFF_DATA': {
      return {
        ...state,
        miaHandoffStats: action.data.mia_handoff_stats,
        miaHandoffAgentStats: action.data.mia_handoff_agent_stats || []
      };
    }
    case 'SET_MESSAGES_BY_HOUR': {
      return {
        ...state,
        messagesByHour: action.data.messages
      };
    }
    case 'SET_NEW_CONTACTS_BY_HOUR': {
      return {
        ...state,
        newContactsByHour: action.data.contacts
      };
    }
    case 'SET_RESPONSE_TIME_BY_HOUR_ENABLED': {
      return {
        ...state,
        messagesByHourEnabled: action.data.messages
      };
    }
    case 'SET_ORDERS_COUNTS': {
      return {
        ...state,
        ordersCount: {
          total: action.data.stats.total || 0,
          success: action.data.stats.success || 0,
          pending: action.data.stats.pending || 0,
          canceled: action.data.stats.canceled || 0
        }
      };
    }
    case 'SET_SALES_TOTAL': {
      return {
        ...state,
        salesStat: {
          total: parseFloat(action.data.stats.total_sold) || 0.0,
          pending: parseFloat(action.data.stats.total_pending_balance) || 0.0
        }
      };
    }
    case 'SET_TOTAL_TRANSACTIONS': {
      return {
        ...state,
        transactionsCount: action.data.stats || 0
      };
    }
    case 'SET_TOTAL_DAILY_SALES': {
      return {
        ...state,
        dailySalesStat: action.data.stats || {}
      };
    }
    case 'SET_SALES_BY_PLATFORM': {
      return {
        ...state,
        salesByPlatform: action.data.stats || {}
      };
    }
    case 'SET_SALES_BY_AGENT': {
      return {
        ...state,
        salesByAgent: action.data.stats || []
      };
    }
    case 'SET_SALES_BY_CUSTOMER_STAT': {
      return {
        ...state,
        salesByCustomerStat: action.data.stats || []
      };
    }
    case 'SET_SALES_BY_PRODUCT_STAT': {
      return {
        ...state,
        salesByProductStat: action.data.stats || []
      };
    }
    case 'SET_SALES_BY_CATEGORY_STAT': {
      return {
        ...state,
        salesByCategoryStat: action.data.stats || []
      };
    }
    case 'SET_SALES_BY_SUBCATEGORY_STAT': {
      return {
        ...state,
        salesBySubcategoryStat: action.data.stats || []
      };
    }
    case 'SET_SALES_BY_CAMPAIGN': {
      return {
        ...state,
        salesByCampaign: action.data?.stats ?? []
      };
    }
    case 'SET_SALES_BY_BRAND_STAT': {
      return {
        ...state,
        salesByBrandStat: action.data.stats || []
      };
    }
    case 'SET_TAGS_BY_CONTACTS': {
      return {
        ...state,
        totalTags: action.data.total_tags || 0,
        tagStats: action.data.tags_stats || []
      };
    }
    case 'SET_ATTRIBUTION_CHANNEL_STATS': {
      return {
        ...state,
        attributionChannelStats: action.data,
        attributionChannelStatsError: null
      };
    }
    case 'SET_ATTRIBUTION_CHANNEL_STATS_LOADING': {
      return {
        ...state,
        attributionChannelStatsLoading: action.payload
      };
    }
    case 'SET_ATTRIBUTION_CHANNEL_STATS_ERROR': {
      return {
        ...state,
        attributionChannelStats: null,
        attributionChannelStatsLoading: false,
        attributionChannelStatsError: action.payload
      };
    }
    case 'SET_ATTRIBUTION_FUNNEL_PIPELINE_STATS': {
      return {
        ...state,
        attributionFunnelPipelineStats: action.data,
        attributionFunnelPipelineStatsError: null
      };
    }
    case 'SET_ATTRIBUTION_FUNNEL_PIPELINE_STATS_LOADING': {
      return {
        ...state,
        attributionFunnelPipelineStatsLoading: action.payload
      };
    }
    case 'SET_ATTRIBUTION_FUNNEL_PIPELINE_STATS_ERROR': {
      return {
        ...state,
        attributionFunnelPipelineStats: null,
        attributionFunnelPipelineStatsLoading: false,
        attributionFunnelPipelineStatsError: action.payload
      };
    }
    case 'CLEAR_ATTRIBUTION_STATS': {
      return {
        ...state,
        attributionChannelStats: null,
        attributionFunnelPipelineStats: null,
        attributionChannelStatsLoading: false,
        attributionChannelStatsError: null,
        attributionFunnelPipelineStatsLoading: false,
        attributionFunnelPipelineStatsError: null
      };
    }
    case 'SET_LOADING_SALES_STATS': {
      return {
        ...state,
        loadingSalesStats: action.payload,
        salesStatsSummaryLoaded: action.payload ? false : state.salesStatsSummaryLoaded
      };
    }
    case 'SET_SALES_STATS_ERROR': {
      return {
        ...state,
        loadingSalesStats: false,
        salesStatsSummaryLoaded: true,
        salesStatsError: action.payload
      };
    }
    case 'SET_FULL_DASHBOARD_STATS': {
      return {
        ...state,
        loadingSalesStats: false,
        salesStatsSummaryLoaded: true,
        salesStatsError: null,
        ordersCount: {
          total: action.data.total_orders.total || 0,
          success: action.data.total_orders.success || 0,
          pending: action.data.total_orders.pending || 0,
          canceled: action.data.total_orders.canceled || 0
        },
        salesStat: {
          total: parseFloat(action.data.total_sold.total_sold) || 0.0,
          pending: parseFloat(action.data.total_sold.total_pending_balance) || 0.0
        },
        salesReconciliation: {
          totalSalesAllOrders: parseFloat(action.data.total_sales_all_orders) || 0.0,
          totalSalesAttributedProducts: parseFloat(action.data.total_sales_attributed_products) || 0.0,
          totalSalesUnattributed: parseFloat(action.data.total_sales_unattributed) || 0.0
        },
        dailySalesStat: action.data.total_daily_sales || {},
        transactionsCount: action.data.total_transactions || 0,
        salesByPlatform: action.data.sales_by_channel || {},
        salesByAgent: action.data.sales_by_agent || [],
        salesByCustomerStat: action.data.sales_by_customer || [],
        salesByProductStat: action.data.sales_by_product || [],
        salesByCategoryStat: action.data.sales_by_category || [],
        salesBySubcategoryStat: action.data.sales_by_subcategory || [],
        salesByBrandStat: action.data.sales_by_brand || []
      };
    }
    default:
      return state;
  }
};

export default statsReducer;
